// services/tallerService.js
import api from './axiosConfig';
const url = '/api/revisiones';

const LIMITE_DEFAULT = 500;

const construirFormDataFotos = (formData, fotosFinal) => {
  const fotografiasMeta = fotosFinal.map((foto, index) => ({
    orden: index + 1, // el orden final = posición actual en la lista, tras eliminar/agregar
    tipo: foto.existente ? 'existente' : 'nueva',
    id_registro: foto.existente ? foto.id_registro : null,
  }));

  formData.append('fotografiasMeta', JSON.stringify(fotografiasMeta));

  fotosFinal.forEach((foto, index) => {
    if (!foto.existente && foto.file) {
      formData.append(`foto_${index + 1}`, foto.file); // solo las nuevas suben binario
    }
  });
};

async function guardarPaso1(revisionId, payload) {
  const ruta = revisionId 
    ? `${url}/${revisionId}/paso1` 
    : `${url}/paso1`;

  try {
    const response = await api.post(ruta, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
}

// Paso 2: diagnóstico, repuestos y fotografías (multipart — las fotos son binarios)
async function guardarPaso2(revisionId, payload) {
  const formData = new FormData();
  
  formData.append('trabajoTaller', JSON.stringify({
    diagnostico: payload.diagnostico,
    recomendado: payload.recomendado,
    realizado: payload.realizado,
    obs_mecanico: payload.obs_mecanico,
  }));

  formData.append('repuestos', JSON.stringify(payload.repuestos ?? []));

  formData.append('tallerCompleto', String(payload.tallerCompleto ?? false));

  construirFormDataFotos(formData, payload.fotografias);

  try {
    const response = await api.post(
      `${url}/${revisionId}/paso2`, 
      formData
    );

    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
}

async function guardarPaso3(revisionId, payload) {
  try {
    const response = await api.post(
      `${url}/${revisionId}/paso3`, 
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
}

async function listarRevisiones(filtros = {}) {
  const params = { limite: filtros.limite ?? LIMITE_DEFAULT };

  if (filtros.id_centrocosto) params.id_centrocosto = filtros.id_centrocosto;
  if (filtros.estado) params.estado = filtros.estado;
  if (filtros.id_trabajador) params.id_trabajador = filtros.id_trabajador;
  if (filtros.desde) params.desde = filtros.desde;
  if (filtros.hasta) params.hasta = filtros.hasta;

  const { data } = await api.get(url, { params });
  return data.revisiones ?? [];
}

async function obtenerRevision(revisionId) {
  try {
    const response = await api.get(url+`/${revisionId}`);

    if ( response.data.ok  ){
      return response.data.revision || [];
    }

  } catch (error) {
    throw error.response?.data.msg || error;
  }
}

async function entregarVehiculo(revisionId) {
  try {
    const response = await api.post(
      `${url}/${revisionId}/entregar`,
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.msg ||
      error.message ||
      'No se pudo registrar la entrega.'
    );
  }
}

async function verPdfOficial(revisionId) {
  try {
    const response = await api.get(`${url}/${revisionId}/pdf-oficial`, 
      { responseType: 'blob' }
    );
    return response.data;

    // const blobUrl = URL.createObjectURL(response.data);
    // window.open(blobUrl, '_blank');
    // Libera el blob después de un momento, no inmediatamente,
    // para darle tiempo a la pestaña nueva de terminar de cargarlo
    // setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);

  } catch (error) {
    // Si el backend respondió con JSON de error (ej. 404), viene como blob también
    // hay que leerlo como texto para mostrar el mensaje real
    if (error.response?.data instanceof Blob) {
      try {
        const texto = await error.response.data.text();
        const data = JSON.parse(texto);
        throw data.msg || 'No se pudo abrir el PDF.';
      } catch (e) {
        throw typeof e === 'string' ? e : 'No se pudo abrir el PDF.';
      }
    }
    throw error.response?.data?.msg || 'No se pudo abrir el PDF.';
  }
}

const revisionService = {
  guardarPaso1, guardarPaso2, guardarPaso3, 
  listarRevisiones, obtenerRevision, 
  entregarVehiculo, verPdfOficial
}
export default revisionService;